(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "axios"], factory);
	else if(typeof exports === 'object')
		exports["vue-ajax-form"] = factory(require("vue"), require("axios"));
	else
		root["vue-ajax-form"] = factory(root["vue"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 